import { IPayloadLogin } from '../../../services/modules/auth/auth-interface';
import {
  SET_LOADING,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  REFRESH_REQUEST,
  CLEAR_STATE,
  SET_USER_SELECTED_FOR_CONTEXT,
  OPEN_CHANGE_PASSWORD_MODAL,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_CANCEL,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_LOADING
} from './auth-constants';
import { UserAuthInterface } from './auth-interface';

export function setLoading(loading: Boolean) {
  return {
    type: SET_LOADING,
    loading
  };
}

export function loginRequest(payload: IPayloadLogin) {
  return {
    type: LOGIN_REQUEST,
    payload
  };
}

export function setUserSelectedForContext(payload: UserAuthInterface) {
  return {
    type: SET_USER_SELECTED_FOR_CONTEXT,
    payload
  };
}

export function loginSucess(payload: any) {
  return {
    type: LOGIN_SUCCESS,
    payload
  };
}

export function logoutRequest() {
  return {
    type: LOGOUT_REQUEST
  };
}

export function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS
  };
}

export function RefreshRequest() {
  return {
    type: REFRESH_REQUEST
  };
}

export function resetPasswordRequest(email: string) {
  return {
    type: RESET_PASSWORD_REQUEST,
    email
  };
}

export function resetPasswordSuccess() {
  return {
    type: RESET_PASSWORD_SUCCESS
  };
}

export function clearState() {
  return {
    type: CLEAR_STATE
  };
}

export function openChangePasswordModal(token: string, oldPassword: string) {
  return {
    type: OPEN_CHANGE_PASSWORD_MODAL,
    payload: {
      token,
      oldPassword
    }
  };
}

export function changePasswordRequest(newPassword: string) {
  return {
    type: CHANGE_PASSWORD_REQUEST,
    newPassword
  };
}

export function changePasswordSuccess() {
  return {
    type: CHANGE_PASSWORD_SUCCESS
  };
}

export function changePasswordCancel() {
  return {
    type: CHANGE_PASSWORD_CANCEL
  };
}

export function changePasswordLoading(loading: boolean) {
  return {
    type: CHANGE_PASSWORD_LOADING,
    payload: loading
  };
}
